function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10,0C5.6,0,2,3.5,2,7.9c0,0.3,0,0.6,0.1,0.8C2.3,11,3.7,13.5,6,16.1c0.8,1,1.8,1.9,2.8,2.8 c0.2,0.2,0.4,0.4,0.6,0.5L10,20l0.6-0.6c0.2-0.2,0.4-0.3,0.6-0.5c1-0.9,1.9-1.8,2.8-2.8c2.3-2.7,3.7-5.2,3.9-7.4 C18,8.4,18,8.2,18,7.9C18,3.5,14.4,0,10,0z M16,8.5c-0.2,1.8-1.4,4-3.5,6.4c-0.8,0.9-1.6,1.7-2.5,2.5c-0.9-0.8-1.7-1.7-2.5-2.5 c-2-2.3-3.2-4.5-3.5-6.4c0-0.2,0-0.4,0-0.6C4,4.6,6.7,2,10,2s6,2.6,6,5.9C16,8.1,16,8.3,16,8.5z M12,8c0,1.1-0.9,2-2,2S8,9.1,8,8 s0.9-2,2-2S12,6.9,12,8z"
});

var SvgAddress = function SvgAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address.44021a1d.svg";
export { ForwardRef as ReactComponent };